import type { UserInputValidationError } from '@tectonics/prs/validation';

export function validateCustomerName(customerName: string): UserInputValidationError | undefined {
  if(!(customerName && customerName.trim())) {
    return { id: 'empty' };
  }

  if(customerName.length > 100) {
    return { id: 'invalid-pattern'};
  }

  return undefined;
}
